module.exports = __webpack_public_path__ + "d5fe2ebd8f4b00597c76af4c637c9ab5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fair/business4.png
// module id = ./assets/images/fair/business4.png
// module chunks = 0